import store from '../redux/store';
import axios from 'axios';
import history from './../router/history';
import Cookies from 'js-cookie';

function userLogout(withRedirect: boolean = true): void {
	store.dispatch({ type: 'reset-state' });
	axios.defaults.headers.common['Authorization'] = '';
	Cookies.remove('Token');
	if (withRedirect) {
		history.push('/login');
	}
}

const deinitialization = {
	userLogout,
};

export default deinitialization;
